import { api } from "./api";
import { ContactFormType } from "../components/Contact/types";

export const sendContactEmail = (body: ContactFormType) => {
  return api.post(`/api/v1/contact/`, body);
};
